<div class="bfx-execution-monitor-container">
  <div class="bfx-em-header">
    <div class="bfx-em-top-row">
      <div class="bfx-top-left">
        <div>
          <span class="bfx-em-label">{{data.totalExecutedLabel}}:</span>
          <span class="bfx-em-amounts"> {{data.totalExecuted}}{{data.prePipsPricePart}}</span>
          <span class="bfx-em-pips">{{data.pipsPricePart}}</span>
          <span class="bfx-em-amounts">{{data.postPipsPricePart}}</span>
        </div>
        <div>
          <span class="bfx-em-label">{{labels.totals.totalRemaining}}:</span>
          <span class="bfx-em-amounts">{{data.totalRemaining}}</span>
        </div>
      </div>
      <div class="bfx-top-right">
        <bfx-badge
          class="bfx-em-state"
          [intent]="data.panelIntent"
          [showIcon]="true"
          emphasis="bold"
          [badgeText]="data.orderState"
        >
        </bfx-badge>
        <div class="bfx-em-toolbar-panel">
          <bfx-icon-button
            *ngIf="data.hasVisibility"
            size="md"
            iconClass="icon-info"
            title="{{labels.buttons.info}}"
            (action)="onShowDetails($event)"
          ></bfx-icon-button>
        </div>
      </div>
    </div>
  </div>

  <bfx-callout
    *ngIf="useLocalCallout"
    [calloutType]="data.localActionCallout?.calloutType"
    calloutSize="sm"
    [message]="data.localActionCallout?.calloutMessage"
    [tooltip]="data.localActionCallout?.calloutTooltip"
    [displayTime]="4000"
    (onCalloutHide)="onCalloutHidden()"
  >
  </bfx-callout>

  <!-- The footer bar with progress and buttons -->
  <div class="bfx-em-footer">
    <!-- Progress bar - in the bottom bar to save vertical space -->
    <div class="bfx-em-progress">
      <div class="progress-bar-container">
        <div class="progress-bar-track"></div>
        <div class="progress-bar-indicator" [style.width.%]="data.progressBar.value"></div>
      </div>
      <div class="bfx-em-progress-label">
        {{data.progressBar.valueStr}} {{labels.totals.percentFilled}}
      </div>
    </div>
    <div class="bfx-em-footer-actions">
      <button
        pButton
        type="button"
        class="bfx-button-secondary-moderate-unsized bfx-button-sm"
        (click)="onModify($event)"
        [label]="labels.buttons.modify"
        [style.display]="data.buttonVisible.modify ? 'block' : 'none'"
        [disabled]="!data.buttonEnabled.modify"
      ></button>
      <button
        pButton
        type="button"
        class="bfx-button-secondary-moderate-unsized bfx-button-sm"
        (click)="onPause($event)"
        [label]="labels.buttons.pause"
        [style.display]="data.buttonVisible.pause ? 'block' : 'none'"
        [disabled]="!data.buttonEnabled.pause"
      ></button>
      <button
        pButton
        type="button"
        class="bfx-button-secondary-moderate-unsized bfx-button-sm"
        (click)="onResume($event)"
        [label]="labels.buttons.resume"
        [style.display]="data.buttonVisible.resume ? 'block' : 'none'"
        [disabled]="!data.buttonEnabled.resume"
      ></button>
      <button
        pButton
        type="button"
        class="bfx-button-secondary-moderate-unsized bfx-button-sm"
        (click)="onFillNow( $event)"
        [label]="labels.buttons.fillNow"
        [style.display]="data.buttonVisible.fillNow ? 'block' : 'none'"
        [disabled]="!data.buttonEnabled.fillNow"
      ></button>
      <button
        pButton
        type="button"
        class="bfx-button-negative-moderate-unsized bfx-button-sm"
        (click)="onCancel($event)"
        [label]="labels.buttons.cancel"
        [style.display]="data.buttonVisible.cancel ? 'block' : 'none'"
        [disabled]="!data.buttonEnabled.cancel"
      ></button>
    </div>
  </div>
</div>
